import { get, post } from '../utils/http';

/**
 * 获取公司列表
 * @param {*} params 
 * pageIndex
 * pageSize
 * keyword
 */
export function getCompanyList(params) {
  return get('/api/tenant', params)
}

/**
 * 获取账号列表
 * @param {*} params 
 * pageIndex
 * pageSize
 * agentRole 角色
 * searchStr 搜索关键词
 * searchTenant 公司 
 * searchOrgAccount 机构
 */
export function getAccountList(params) {
  return get('/api/agents/simple', params);
}

/**
 * 获取账号列表 旧
 * @param {*} params 
 * pageIndex
 * pageSize
 * agentRole 角色
 * searchStr 搜索关键词
 * searchTenant 公司 
 * searchOrgAccount 机构
 */
 export function getAccountListOld(params) {
    return get('/api/agent_list', params);
  }
/**
 * 踢出用户
 * @param {} agentId
 */
export function kickOutUser(agentId) {
  return get(`/api/agents/kickoutAgent/${agentId}`);
}
/**
 * 删除账号
 * @param {*} params 
 * agentIds 
 */
export function deleteAccount(params) {
  return post('/api/agent/delete_accounts', params);
}
/**
 * 获取机构下可使用的角色
 * @param {*} params 
 * orgAccount 机构id
 */
export function getEnabledRoleList(params) {
  return get('/api/sysRole/available', params);
}
/**
 * 查询可用的雇主公司
 * @param {*} params 
 * agentId
 */
export function getActiveEmployer(params) {
  return get('/api/lossAss/employer/active', params);
}
/**
 * 获取租户的可选权限
 * @param {*} params 
 * tenant 坐席所属租户的id
 */
export function getPermissionList(params) {
  return get('/api/agents/permissions', params);
}
/**
 * 创建账号
 * @param {*} params 
 */
export function createAccount(params) {
  return post('/api/agents', params);
}
/**
 * 更新账号
 * @param {*} id 
 * @param {*} params  
 */
export function updateAccount(id, params) {
  return post(`/api/account/${id}`, params)
}
/**
 * 更新账号状态
 * @param {*} params 
 * agentId
 * accountStatus
 */
export function updateAccountStatus(params) {
  return post('/api/agent/setstatus', params)
}

export function getExportPermission() {
  return get('/api/lossAss/report/exportPermission')
}